import { createAction } from '@reduxjs/toolkit';

export const updateEventConfig = createAction<AccountEventConfig>(
  'auth/updateEventConfig'
);
export const forceLogout = createAction('auth/forceLogout');
